var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "a-col",
            { attrs: { span: 24 } },
            [
              _c(
                "div",
                { staticClass: "siftArea" },
                [
                  _c("a-input-search", {
                    staticStyle: { width: "170px", "margin-right": "15px" },
                    attrs: { placeholder: "请输入学生名字" },
                    on: { change: _vm.searchName },
                    model: {
                      value: _vm.queryParam.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "name", $$v)
                      },
                      expression: "queryParam.name",
                    },
                  }),
                  _c("a-select", {
                    staticStyle: { width: "100px", "margin-right": "15px" },
                    attrs: { options: _vm.dateRangeOptions },
                    model: {
                      value: _vm.queryParam.dateType,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "dateType", $$v)
                      },
                      expression: "queryParam.dateType",
                    },
                  }),
                  _c("a-range-picker", {
                    staticStyle: { width: "250px" },
                    attrs: { value: _vm.rangeDate },
                    on: { change: _vm.onRangeChange },
                  }),
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-left": "15px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.tableQuery },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "download" },
                      on: { click: _vm.exportXls },
                    },
                    [_vm._v("\n          导出\n        ")]
                  ),
                ],
                1
              ),
              _c("TableList", {
                attrs: {
                  columns: _vm.schoolTableConfig.columns,
                  tableData: _vm.schoolTableConfig.tableData,
                  scroll: false,
                  loading: _vm.schoolTableConfig.loading,
                  pagination: _vm.schoolTableConfig.pagination,
                },
                on: { change: _vm.handleTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "action",
                    fn: function (slotProps) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "action-detail",
                            on: {
                              click: function ($event) {
                                return _vm.viewDetails(slotProps)
                              },
                            },
                          },
                          [_vm._v("查看详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ViewKeyPointModal", { ref: "viewKeyPointModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }